<template>
  <div class="type">
    <div class="type-head">
      {{ title }}
    </div>
    <div class="type-con">
      <div
        v-for="(item, itemIndex) in items"
        :key="itemIndex"
        class="type-item pointer"
        :style="{
          color: itemColorMap[index],
          border: `1px solid ${itemColorMap[index]}`,
        }"
        @click="childClick(item)"
      >
        <div class="ellipsis">{{ item.serviceCategoryName }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      bgMap: {
        0: "images/mallHome/header-blue.png",
        1: "images/mallHome/header-orange.png",
        2: "images/mallHome/header-red.png",
      },
      itemColorMap: {
        0: "#7EBCF2",
        1: "#EEAB6C",
        2: "#F26F71",
      },
    };
  },
  methods: {
    childClick(data) {
      this.$router.push({
        name: "mallStrict",
        query: { cateId: data.serviceCategoryPid },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.type {
  position: relative;
  overflow: hidden;
  background: url($oss-url + "home/bg/bg-1.png") no-repeat center 0 / 100% 50px,
    url($oss-url + "home/bg/bg-2.png") no-repeat center 100% / 100% 50px;
  background-color: #fff;
  &-head {
    margin: 15px auto;
    width: 100px;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    text-align: center;
    color: white;
    font-size: 15px;
    background: #ff1d36;
  }
  &-con {
    display: grid;
    grid-template-columns: repeat(2, 90px);
    gap: 10px;
    padding: 10px;
    overflow: auto;
  }
  &-item {
    height: 25px;
    line-height: 25px;
    border-radius: 5px;
    text-align: center;
    > div {
      max-width: 70px;
    }
  }
}
</style>
